import { React, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Card, Heading, Text, Tooltip, MTag, DotsThree, Modal, Button, Dropdown, MNotification, MLink } from "@cisco/spaces-dash-lib-styleguide";
import { AdminAppApproval } from "@cisco/spaces-dash-app-appcenter";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import moment from "moment";
import useLoader from "../../hooks/useLoader";
import * as PartnerDashboardService from "../../service/partner-dashboard-service";
import { I18nContext } from "../../contexts/i18nContext";
import { PropertiesContext } from "../../contexts/propertiesContext";
import "./list-apps.scss";

function ListApps(props) {
  const { properties } = useContext(PropertiesContext);
  const { appActivationMap, mtcAppAllowed, appData, resetList, appEdit, apps: propsApps, copyAppFn } = props;
  const i18n = useContext(I18nContext);
  const [apps, setApps] = useState([]);
  const { setToastMessage } = useNotification();
  const [appForDelete, setAppForDelete] = useState({});
  const [appForDraft, setAppForDraft] = useState({});
  const [rejectionApp, setRejectionApp] = useState({});
  const [rejectedDetailsPopup, setRejectedDetailsPopup] = useState(false);
  const [appDeleteConfirmationShow, setAppDeleteConfirmationShow] = useState(false);
  const [draftVersionShow, setDraftVersionShow] = useState(false);
  const [isEditAppPopupOpen, setIsEditAppPopupOpen] = useState(false);
  const [appForStageUpdate, setAppForStageUpdate] = useState({});
  const [showUpdateStagePopup, setShowUpdateStagePopup] = useState(false);
  const [updateStageMsgKeys, setUpdateStageMsgKeys] = useState({});
  const [selectedPartnerApp] = useState(null);
  const [rejectionComments, setRejectionComments] = useState("");
  const [activationApp, setActivationApp] = useState(null);
  const [activations, setActivations] = useState(null);
  const [activationDetails, setActivationDetails] = useState(null);
  const [showActivationPopup, setShowActivationPopup] = useState(false);
  const [showActivationDetailsPopup, setShowActivationDetailsPopup] = useState(false);

  const [showFirehoseWarningPopup, setShowFirehoseWarningPopup] = useState(false);
  const [firehoseWarningRegion, setFirehoseWarningRegion] = useState("");

  const [showSubmissionErrorPopup, setShowSubmissionErrorPopup] = useState(false);
  const [appForSubmission, setAppForSubmission] = useState({});
  const [submissionErrorMsg, setSubmissionErrorMsg] = useState("");
  const [showDeleteDueToActivationError, setShowDeleteDueToActivationError] = useState(false);
  const [deleteAppActivationErrorMsg, setDeleteAppActivationErrorMsg] = useState(false);
  const navigate = useNavigate();
  const { setLoading } = useLoader();

  const [isEuDomain, setIsEuDomain] = useState(false);
  const [isSgDomain, setIsSgDomain] = useState(false);

  const [euRegionAvailable, setEuRegionAvailable] = useState(false);
  const [sgRegionAvailable, setSgRegionAvailable] = useState(false);

  useEffect(() => {
    console.log("appActivationMap::", appActivationMap);
  }, [appActivationMap]);

  const getPartnerRegionStatus = () => {
    PartnerDashboardService.enablePartnerStatus("eu", true)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status) {
            setEuRegionAvailable(true);
          } else {
            setEuRegionAvailable(false);
          }
        } else {
          setEuRegionAvailable(false);
        }
      })
      .catch((error) => {
        setEuRegionAvailable(false);
        console.log(error);
      });

    PartnerDashboardService.enablePartnerStatus("sg", true)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status) {
            setSgRegionAvailable(true);
          } else {
            setSgRegionAvailable(false);
          }
        } else {
          setSgRegionAvailable(false);
        }
      })
      .catch((error) => {
        setSgRegionAvailable(false);
        console.log(error);
      });
  };

  const editPartner = (app, stage, isView) => {
    console.log("Edit App", app, stage, isView);
    appEdit(app, stage, isView);
  };

  const sendEmailNotification = (appForEditState, actionType) => {
    const emailDetails = {
      appName: appForEditState.appName,
      appId: appForEditState.appId,
      submissionDate: moment(new Date()).format("MMMM Do YYYY, h:mm a"),
      stage: actionType,
      action: actionType,
      adminRedirectUrl: properties ? `${properties.baseUrl}/admin/login?redirectUrl=/admin/apps&appId=${appForEditState.appId}` : `/admin/login?redirectUrl=/admin/apps&appId=${appForEditState.appId}`,
      partnerRedirectUrl: properties ? `${properties.baseUrl}/login?redirectUrl=/home&appId=${appForEditState.appId}` : `/login?redirectUrl=/home&appId=${appForEditState.appId}`,
      version: appForEditState.version,
      emailType: "PARTNER_NOTIFICATION"
    };
    PartnerDashboardService.sendMail(emailDetails)
      .then((data) => {
        if (data.status) {
          console.log("Email Sent to Partner/Admin", data);
        } else {
          console.log("Error on sending Email to Partner", data);
        }
      })
      .catch((error) => {
        console.log("Error on sending Email to Partner", error);
      });
  };

  const proceedToUpdateStage = () => {
    const stageObj = {
      appId: appForStageUpdate.appId,
      stage: appForStageUpdate.stage
    };
    // PartnerDashboardService.partnerStageStrapiUpdate(stageObj)
    PartnerDashboardService.partnerStageUpdate(stageObj)
      .then((response) => {
        if (response && response.data) {
          setShowUpdateStagePopup(false);
          setAppForStageUpdate({});
          if (appForStageUpdate.stage === "LIVE" || appForStageUpdate.stage === "SUBMIT") {
            sendEmailNotification(appForStageUpdate, appForStageUpdate.stage);
          }
          const msg = `${i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.success-app-state-moved-msg")}: ${appForStageUpdate.stage}`;
          setToastMessage(msg, 5000, "positive");
          resetList();
        } else {
          setShowUpdateStagePopup(false);
          setAppForStageUpdate({});
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.error-on-updating-stage-msg"), 4000, "negative");
        }
      })
      .catch((error) => {
        setShowUpdateStagePopup(false);
        setAppForStageUpdate({});
        console.log(error);
      });
  };

  const cancelUpdateStagePopup = () => {
    setShowUpdateStagePopup(false);
    setAppForStageUpdate({});
  };

  const updateStage = (appId, appName, stage, version) => {
    setAppForStageUpdate({
      appId,
      appName,
      stage,
      version
    });
    setShowUpdateStagePopup(true);
  };

  const confirmTest = (app) => {
    console.log("confirmTest::", app);
    setUpdateStageMsgKeys({
      heading: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.move-to-test-text"),
      query: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.sure-want-to-move-app-to-testing-text"),
      note: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-text"),
      note2: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.ensure-completed-integration-text"),
      button: i18n.t("partner-dashboard-app.auth.login.login-partner-base.continue-text")
    });
    updateStage(app.appId, app.appName, "TEST", app.draftConfig.version);
  };

  const checkAppAllowedForSubmission = (appSubmission) => {
    if (!appSubmission.draftConfig.appTile.healthCheckUrl || !appSubmission.draftConfig.appTile.healthStatusUrl || !appSubmission.draftConfig.appTile.appStatusUrl) {
      setShowSubmissionErrorPopup(true);
      setSubmissionErrorMsg("Please configure your Monitoring URLs for this App (from the Behaviors section) before submitting the App for review");
      return false;
    }
    if (appSubmission.draftConfig.applicationType === "MTC") {
      // check if the App's OAuth URLs are non-trigue URLs
      // with the exception of Trigue/Testing Customers
      let trigueOauthUrlsConfigured = false;
      const propT = { ...properties };
      // propT.partnerTrigueOauthDomains = "[https://trigue.proximitymx.io,https://trigue.dnaspaces.io,https://partnersite.qa-dnaspaces.io]";
      // propT.partnerTrigueCustomers = "[334, 420]";
      const trigueCustomers = propT?.partnerTrigueCustomers ? JSON.parse(propT?.partnerTrigueCustomers) : [];
      const tId = window.sessionStorage.getItem("tenantId");
      const tenantId = tId ? JSON.parse(tId) : 0;
      if (trigueCustomers && trigueCustomers.length && trigueCustomers.indexOf(tenantId) > -1) {
        // proceed to show app submission confirmation as above cases are not met
        setShowSubmissionErrorPopup(false);
        setSubmissionErrorMsg("");
        return true;
      }
      // is not a Trigue/Testing Customer
      // check OAuth URLs
      if (propT?.partnerTrigueOauthDomains) {
        let trigueDomainsStr = propT?.partnerTrigueOauthDomains;
        trigueDomainsStr = trigueDomainsStr.substring(1, trigueDomainsStr.length - 1);
        const trigueDomains = trigueDomainsStr.split(",");
        const { dashboardUrl, oAuthTokenURL, partnerAppInfoURL, redirectUri } = appSubmission.draftConfig.appTile;
        if (trigueDomains && trigueDomains.length) {
          trigueDomains.forEach((domain) => {
            if (dashboardUrl.indexOf(domain) > -1) {
              trigueOauthUrlsConfigured = true;
            } else if (oAuthTokenURL.indexOf(domain) > -1) {
              trigueOauthUrlsConfigured = true;
            } else if (partnerAppInfoURL.indexOf(domain) > -1) {
              trigueOauthUrlsConfigured = true;
            } else if (redirectUri.indexOf(domain) > -1) {
              trigueOauthUrlsConfigured = true;
            }
          });
        }
      }
      if (trigueOauthUrlsConfigured) {
        setShowSubmissionErrorPopup(true);
        setSubmissionErrorMsg(
          "Looks like you are still using Trigue URLs for your app integration. Please configure your OAuth integration URLs for this App (in the App Tile section) before submitting the App for review."
        );
        return false;
      }
      // proceed to show app submission confirmation as above cases are not met
      setShowSubmissionErrorPopup(false);
      setSubmissionErrorMsg("");
      return true;
    }
    // proceed to show app submission confirmation as above cases are not met
    setShowSubmissionErrorPopup(false);
    setSubmissionErrorMsg("");
    return true;
  };

  const confirmSubmission = (app) => {
    setAppForSubmission(app);
    if (checkAppAllowedForSubmission(app)) {
      console.log("confirmSubmission::", app);
      setUpdateStageMsgKeys({
        heading: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.submit-app-text"),
        query: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.sure-submit-app-for-review-text"),
        note: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.before-submit-app-text"),
        note2: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.ensure-completed-integration-text"),
        button: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.submit-text")
      });
      updateStage(app.appId, app.appName, "SUBMIT", app.draftConfig.version, app);
    }
  };

  const confirmPublish = (app) => {
    console.log("confirmPublish::", app);
    setUpdateStageMsgKeys({
      heading: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.publish-app-text"),
      query: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.sure-want-to-publish-app-text"),
      button: i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.publish-text")
    });
    updateStage(app.appId, app.appName, "LIVE", app.draftConfig.version);
  };

  const confirmMakeDraft = (dApp) => {
    console.log("confirmMakeDraft::", dApp);
    setAppForDraft(dApp);
    setDraftVersionShow(true);
  };

  const showRejectedDetails = (app) => {
    console.log("showRejectedDetails::", app);
    if (app.draftConfig.stage == "REJECTED") {
      setRejectionApp(app);
      setRejectedDetailsPopup(true);
      if (app.draftConfig.stateHistory) {
        const appVersion = app.draftConfig.version;
        app.draftConfig.stateHistory.forEach((versionObj) => {
          if (appVersion === versionObj.version) {
            if (versionObj.action && versionObj.action.length > 0) {
              let lastRejectedIndex = -1;
              versionObj.action.forEach((action, index) => {
                if (action.stage && action.stage.toLowerCase() === "rejected") {
                  lastRejectedIndex = index;
                }
              });
              if (lastRejectedIndex > -1) {
                const rejectionCmts = versionObj.action[lastRejectedIndex].comments ? versionObj.action[lastRejectedIndex].comments : "";
                setRejectionComments(rejectionCmts);
              }
            }
          }
        });
      }
    } else {
      setRejectionApp({});
      setRejectionComments("");
      setRejectedDetailsPopup(false);
    }
  };

  useEffect(() => {
    if (activations && activations.length) {
      console.log("activations::", activations);
      setShowActivationPopup(true);
    }
  }, [activations]);

  const prepareActivations = (activs) => {
    const activationData = [...activs];
    const activationFinalData = [];
    activationData.forEach((act) => {
      /*  Location Names */
      const activation = { ...act };
      const activatedLocations = [...activation.locations];
      activation.locationNames = {};
      const locationObj = {};
      activatedLocations.forEach((location) => {
        locationObj[location._id] = location.name;
      });
      activation.locationNames = locationObj;

      /* Modified Date */
      if (activation.activations && activation.activations.createdOn && activation.activations.createdOn.$date) {
        const modifiedDate = new Date(activation.activations.createdOn.$date).toISOString();
        activation.modifiedDate = moment(modifiedDate).format("H:mm Do MMMM YYYY");
      } else {
        activation.modifiedDate = "NA";
      }
      if (activation.activations && activation.activations.activated) {
        activation.activationMap = [];
        const { activated } = activation.activations;
        Object.keys(activated).forEach((i) => {
          activation.activationMap.push({
            id: i,
            user: activated[i]
          });
        });
      }
      activationFinalData.push(activation);
    });
    return activationFinalData;
  };

  const getActivations = (app) => {
    console.log("getActivations::", app);
    setActivationApp(app);
    PartnerDashboardService.getAllActivationDetails(app.appId)
      .then((response) => {
        if (response && response.data) {
          const activationData = prepareActivations(response.data);
          setActivations(activationData);
          console.log(activationData);
        } else {
          setActivations([]);
          console.log(response);
        }
      })
      .catch((error) => {
        setToastMessage(i18n.t("An error occured while fetching App Activations for this app"), 4000, "negative");
        setActivations([]);
        console.log(error);
      });
  };

  const copyApp = (app) => {
    console.log("copyApp::", app);
    copyAppFn(app);
  };

  const confirmDeleteApp = (app) => {
    console.log("confirmDeleteApp::", app);
    setShowDeleteDueToActivationError(false);
    setLoading(true);
    if (app.draftConfig.stage === "LIVE" || app.draftConfig.stage === "APPROVED") {
      setLoading(false);
      setAppDeleteConfirmationShow(true);
      setAppForDelete(app);
    } else {
      console.log("getActivations::", app);
      setActivationApp(app);
      PartnerDashboardService.getAllActivationDetails(app.appId)
        .then((response) => {
          setLoading(false);
          if (response && response.data && response.data.length > 0) {
            setShowDeleteDueToActivationError(true);
            const activationData = prepareActivations(response.data);
            setActivations(activationData);
            console.log(activationData);
          } else {
            setLoading(false);
            setShowDeleteDueToActivationError(false);
            setAppDeleteConfirmationShow(true);
            setAppForDelete(app);
            console.log(response);
          }
        })
        .catch((error) => {
          setLoading(false);
          setShowDeleteDueToActivationError(false);
          setAppDeleteConfirmationShow(true);
          setAppForDelete(app);
          console.log(error);
        });
    }
  };

  const goToFireHoseTracing = (app) => {
    console.log("goToFireHoseTracing::", app);
    navigate(`firehose/trace/${app.appId}`);
  };

  const goToEuFirehosePopup = (app) => {
    console.log("goToEuFirehosePopup::", app);
    setShowFirehoseWarningPopup(true);
    setFirehoseWarningRegion("eu");
    // navigate(`firehose/trace/${app.appId}`);
  };

  const goToSgFirehosePopup = (app) => {
    console.log("goToSgFirehosePopup::", app);
    setShowFirehoseWarningPopup(true);
    setFirehoseWarningRegion("sg");
    // navigate(`firehose/trace/${app.appId}`);
  };

  const previewPartner = (app, type) => {
    // setSelectedPartnerApp(app);
    // setIsEditAppPopupOpen(true);
    navigate(`app/details/${app.appId}/${type}`);
  };

  const cancelEditAppPopup = () => {
    setIsEditAppPopupOpen(false);
  };

  const closeDeleteModal = () => {
    setAppDeleteConfirmationShow(false);
    setAppForDelete({});
  };

  const deleteApp = (appId) => {
    const appObj = {
      appId
    };
    // PartnerDashboardService.deleteStrapiApp(appObj)
    PartnerDashboardService.deleteApp(appObj)
      .then((response) => {
        if (response && response.data) {
          closeDeleteModal();
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-deleted-successfully-msg"), 5000, "positive");
          resetList();
        } else {
          closeDeleteModal();
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.error-on-deleting-app-msg"), 4000, "negative");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeDraftModal = () => {
    setDraftVersionShow(false);
    setAppForDraft({});
  };

  const makeDraftVersion = (dApp) => {
    if (dApp.appId) {
      const appObj = {
        appId: dApp.appId
      };
      // PartnerDashboardService.makeDraftStrapiVersion(appObj)
      PartnerDashboardService.makeDraftVersion(appObj)
        .then((response) => {
          if (response && response.data) {
            closeDraftModal();
            setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.draft-version-app-creation-msg"), 5000, "positive");
            resetList();
          } else {
            closeDraftModal();
            setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.error-on-making-draft-version-app-msg"), 4000, "negative");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const firehoseWarningPopup = () => {
    return (
      <Modal className="firehost-warning-modal" size="md" isOpen={showFirehoseWarningPopup}>
        <Flex direction="vertical" id="rejection-modal">
          <Heading>
            {firehoseWarningRegion === "eu" && i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-fire-hose-eu-setup-text")}
            {firehoseWarningRegion === "sg" && i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-fire-hose-sg-setup-text")}
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24,
            padding: 24
          }}
        >
          {!euRegionAvailable && firehoseWarningRegion === "eu" && (
            <MNotification style={{ marginBottom: 24 }} status="negative">
              {firehoseWarningRegion === "eu" && i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.donot-have-account-on-eu-region-text")}
            </MNotification>
          )}
          {!sgRegionAvailable && firehoseWarningRegion === "sg" && (
            <MNotification style={{ marginBottom: 24 }} status="negative">
              {firehoseWarningRegion === "sg" && i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.donot-have-account-on-sg-region-text")}
            </MNotification>
          )}
          <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.please-visit-the")}</Heading>
          {euRegionAvailable && properties && properties.partnerDashboardEuUrl && firehoseWarningRegion === "eu" && (
            <MLink target="_blank" href={properties.partnerDashboardEuUrl}>
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-eu-setup-text")}
            </MLink>
          )}
          {sgRegionAvailable && properties && properties.partnerDashboardSgUrl && firehoseWarningRegion === "sg" && (
            <MLink target="_blank" href={properties.partnerDashboardSgUrl}>
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-sg-setup-text")}
            </MLink>
          )}
          {euRegionAvailable && !properties.partnerDashboardEuUrl && firehoseWarningRegion === "eu" && (
            <Text>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-eu-setup-text")}</Text>
          )}
          {sgRegionAvailable && !properties.partnerDashboardSgUrl && firehoseWarningRegion === "sg" && (
            <Text>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.partner-dashboard-sg-setup-text")}</Text>
          )}
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                setShowFirehoseWarningPopup(false);
                setFirehoseWarningRegion("");
              }}
              style={{ marginRight: 8 }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
            {euRegionAvailable && properties.partnerDashboardEuUrl && firehoseWarningRegion === "eu" && (
              <Button
                kind="primary"
                onClick={() => {
                  setShowFirehoseWarningPopup(false);
                  window.open(properties.partnerDashboardEuUrl, "_blank");
                }}
              >
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.go-to-partner-eu-setup-text")}
              </Button>
            )}
            {sgRegionAvailable && properties.partnerDashboardSgUrl && firehoseWarningRegion === "sg" && (
              <Button
                kind="primary"
                onClick={() => {
                  setShowFirehoseWarningPopup(false);
                  window.open(properties.partnerDashboardSgUrl, "_blank");
                }}
              >
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.go-to-partner-sg-setup-text")}
              </Button>
            )}
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const renderEditLink = (app, type) => {
    if (!mtcAppAllowed && app.applicationType === "MTC") {
      return null;
    }
    if (type === "live") {
      return (
        <Dropdown.Item
          onClick={() => {
            editPartner(app, app.stage, null);
          }}
          label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.edit-text")}
        />
      );
    }
    if (app.draftConfig.stage === "NEW" || app.draftConfig.stage === "TEST" || app.draftConfig.stage === "REJECTED") {
      return (
        <Dropdown.Item
          onClick={() => {
            editPartner(app, app.draftConfig.stage, null);
          }}
          label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.edit-text")}
        />
      );
    }
    return null;
  };

  const liveActionsTemplate = (app) => {
    return (
      <div id={`more-action-for-${app.appName}`}>
        {(isEuDomain || isSgDomain) && (
          <Dropdown id={`more-action-for-${app.appName}`} icon={<DotsThree style={{ width: "30px", height: "30px" }} />} kind="tertiary" placement="right">
            <Dropdown.Item id="firehose-option" onClick={() => goToFireHoseTracing(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
          </Dropdown>
        )}
        {!isEuDomain && !isSgDomain && (
          <Dropdown id={`more-action-for-${app.appName}`} icon={<DotsThree style={{ width: "30px", height: "30px" }} />} kind="tertiary" placement="right">
            <Dropdown.Item id="overview" onClick={() => editPartner(app, app.draftConfig.stage, "view")} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")} />
            {renderEditLink(app, "live")}
            <Dropdown.Item onClick={() => previewPartner(app, "l")} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.preview-app-text")} />
            <Dropdown.Item onClick={() => confirmMakeDraft(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.update-app-text")} />
            {appActivationMap && appActivationMap[app.appId] > 0 && (
              <Dropdown.Item onClick={() => getActivations(app, false)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-activations-text")} />
            )}
            <Dropdown.Item onClick={() => copyApp(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.make-a-copy-of-app-text")} />
            {app.region === "us" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToFireHoseTracing(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
            {app.region === "eu" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToEuFirehosePopup(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
            {app.region === "sg" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToSgFirehosePopup(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
          </Dropdown>
        )}
      </div>
    );
  };

  const draftActionsTemplate = (app) => {
    return (
      <div id={`more-action-for-${app.appName}`}>
        {(isEuDomain || isSgDomain) && (
          <Dropdown id={`more-action-for-${app.appName}`} icon={<DotsThree style={{ width: "30px", height: "30px" }} />} kind="tertiary" placement="right">
            <Dropdown.Item id="firehose-option" onClick={() => goToFireHoseTracing(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
          </Dropdown>
        )}
        {!isEuDomain && !isSgDomain && (
          <Dropdown id={`more-action-for-${app.appName}`} icon={<DotsThree style={{ width: "30px", height: "30px" }} />} kind="tertiary" placement="right">
            <Dropdown.Item id="overview" onClick={() => editPartner(app, app.draftConfig.stage, "view")} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")} />
            {renderEditLink(app, "draft")}
            <Dropdown.Item onClick={() => previewPartner(app, "d")} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.preview-app-text")} />
            {(app.draftConfig.stage === "NEW" || app.draftConfig.stage === "REJECTED") && !app.draftConfig.isInternal && (
              <Dropdown.Item onClick={() => confirmTest(app)} id="app-stage-test" label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.test-text")} />
            )}
            {app.draftConfig.stage === "TEST" && !app.draftConfig.isInternal && (
              <Dropdown.Item id="app-stage-submit" onClick={() => confirmSubmission(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.submit-text")} />
            )}
            {app.draftConfig.stage === "APPROVED" && !app.draftConfig.isInternal && (
              <Dropdown.Item id="app-stage-publish" onClick={() => confirmPublish(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.publish-text")} />
            )}
            {app.draftConfig.stage === "LIVE" && <Dropdown.Item onClick={() => confirmMakeDraft(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.update-app-text")} />}
            {app.draftConfig.stage === "REJECTED" && !app.draftConfig.isInternal && (
              <Dropdown.Item onClick={() => showRejectedDetails(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.rejection-details-text")} />
            )}
            {app.draftConfig.stage === "LIVE" && appActivationMap && appActivationMap[app.appId] > 0 && (
              <Dropdown.Item onClick={() => getActivations(app, false)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-activations-text")} />
            )}
            <Dropdown.Item onClick={() => copyApp(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.make-a-copy-of-app-text")} />
            {(app.draftConfig.stage === "NEW" || app.draftConfig.stage === "REJECTED" || app.draftConfig.stage === "TEST" || app.draftConfig.stage === "SUBMIT") && (
              <Dropdown.Item onClick={() => confirmDeleteApp(app)} id="delete-app-option" label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.delete-app-text")} />
            )}
            {app.draftConfig.region === "us" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToFireHoseTracing(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
            {app.draftConfig.region === "eu" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToEuFirehosePopup(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
            {app.draftConfig.region === "sg" && (
              <Dropdown.Item id="firehose-option" onClick={() => goToSgFirehosePopup(app)} label={i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.trace-firehose-text")} />
            )}
          </Dropdown>
        )}
      </div>
    );
  };

  const stageTemplate = (app) => {
    const stageTexts = {
      LIVE: "partner-dashboard-app.partner-apps.partner-apps-list.live-caps-text",
      NEW: "partner-dashboard-app.partner-apps.partner-apps-list.draft-caps-text",
      TEST: "partner-dashboard-app.partner-apps.partner-apps-list.testing-caps-text",
      SUBMIT: "partner-dashboard-app.partner-apps.partner-apps-list.submitted-caps-text",
      REJECTED: "partner-dashboard-app.partner-apps.partner-apps-list.not-approved-caps-text",
      "UNDER-REVIEW": "partner-dashboard-app.partner-apps.partner-apps-list.under-review-caps-text",
      "UNDER-REVIEW-COMING-SOON": "partner-dashboard-app.partner-apps.partner-apps-list.under-review-caps-text",
      APPROVED: "partner-dashboard-app.partner-apps.partner-apps-list.approved-caps-text"
    };
    const text = stageTexts[app.stage] || "";
    return <span id={`app_${app.appName}_stage_${app.stage}`}>{i18n.t(text)}</span>;
  };

  const getAppName = (nm) => {
    if (nm && nm.length > 22) {
      return (
        <Tooltip title={nm}>
          <span>{`${nm.substr(0, 22)}...`}</span>
        </Tooltip>
      );
    }
    return <span>{nm}</span>;
  };

  const getRegion = (app) => {
    if (app.region === "eu") {
      return <span> | {i18n.t("partner-dashboard-app.partner-apps.admin-app-center.region-europe-text")}</span>;
    }
    if (app.region === "sg") {
      return <span> | {i18n.t("partner-dashboard-app.partner-apps.admin-app-center.region-sg-text")}</span>;
    }
    return "";
  };

  const cardTemplate = (app, index, type) => {
    const fcardTemplate = (
      <Card
        key={index}
        id={`partner-app-list-${app.appName}`}
        style={{
          minWidth: 400,
          maxWidth: 400,
          height: 320
        }}
      >
        <Flex direction="vertical" gap={5} grow>
          <Flex justify="space-between">
            <Text size="p2" weight="semi-bold" style={{ width: "300px", color: "#373C42" }}>
              {type === "live" ? getAppName(app.appName) : getAppName(app.draftConfig.appName)}
              <MTag.Colored size="md" style={{ "margin-left": "10px" }} color={type === "live" ? 4 : 1}>
                {type === "live" ? stageTemplate(app) : stageTemplate(app.draftConfig)}
              </MTag.Colored>
            </Text>
            <div>{type === "live" ? liveActionsTemplate(app) : draftActionsTemplate(app)}</div>
          </Flex>
          <Text size="p3" weight="semi-bold" style={{ "font-size": "12px", color: "#596069" }}>
            {type === "live" ? app.version : app.draftConfig.version} {getRegion(app)}
          </Text>
          {/* <div>
            <MTag size="md">{type === "live" ? stageTemplate(app) : stageTemplate(app.draftConfig)}</MTag>
          </div> */}
          <Text size="p3" color="light" style={{ "font-size": "12px", color: "#596069" }}>
            {app?.appTagLine?.length > 110 ? `${app?.appTagLine?.substr(0, 110)}...` : app.appTagLine}
          </Text>
          {type === "live" && appActivationMap && appActivationMap[app.appId] !== undefined ? (
            <Text size="p3" color="light" style={{ "font-size": "12px", color: "#596069" }}>
              {appActivationMap[app.appId]} Activations
            </Text>
          ) : (
            <Text size="p3" color="light" style={{ "min-height": "20px", "font-size": "12px", color: "#596069" }} />
          )}
          <Card.Well
            style={{
              height: 170,
              background: "#fff"
            }}
          >
            <div className="app-center-image-container">
              {type === "live" ? (
                <img src={app.appIconS3Url} alt="app Icon Alt" className="app-list-responsive-image" />
              ) : (
                <img src={app.draftConfig.appIconS3Url} alt="app Icon Alt" className="app-list-responsive-image" />
              )}
            </div>
          </Card.Well>
          {/* <Flex direction="vertical" style={{ "margin-top": "50px" }}>
            <Flex justify="center" style={{ "padding-left": "10px", "padding-right": "10px" }}>
              <Divider direction="horizontal" />
            </Flex>
            <Flex justify="flex-end" gap={20} style={{ "margin-top": "-8px" }}>
              <div>
                <MLink
                  size="md"
                  onClick={() => {
                    editPartner(app, app.draftConfig.stage, "view");
                  }}
                  id="overview"
                >
                  {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.view-text")}
                </MLink>
              </div>
              {renderEditLink(app, type)}
              <div>{type === "live" ? liveActionsTemplate(app) : draftActionsTemplate(app)}</div>
            </Flex>
          </Flex> */}
        </Flex>
      </Card>
    );
    return fcardTemplate;
  };

  const cardContainerTemplate = (app, index) => {
    return cardTemplate(app, index, app.editType);
  };

  const rejectionDetailsTemplate = () => {
    return (
      <Modal className="delete-app-modal" size="md" isOpen={rejectedDetailsPopup}>
        <Flex direction="vertical" id="rejection-modal">
          <Heading>
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.rejection-details-text")} :<span className="appDelInfo">{rejectionApp?.appName}</span>
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24,
            padding: 24
          }}
        >
          <Heading size="sub-section">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-rejected-text")}</Heading>
          {rejectionComments ? (
            <Text size="p3" weight="regular" style={{ marginTop: 20 }}>
              {rejectionComments}
            </Text>
          ) : (
            ""
          )}
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                setRejectedDetailsPopup(false);
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const deleteAppTemplate = () => {
    return (
      <Modal className="delete-app-modal" size="md" isOpen={appDeleteConfirmationShow}>
        <Flex direction="vertical" id="delete-modal">
          <Heading style={{ "margin-bottom": "10px" }}>
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.delete-app-text")} :
            <span className="appDelInfo">
              {appForDelete ? appForDelete.appName : ""} - {appForDelete ? appForDelete.version : ""}
            </span>
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24
          }}
        >
          <Text>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.sure-want-to-delete-app-text")}</Text>
          <div className="delInfo">
            <div className="delText">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-text")}:{appForDelete.appName}
            </div>
            <div className="delText">
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.version-text")}:{appForDelete.version}
            </div>
          </div>
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                closeDeleteModal();
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
            <Button
              onClick={() => {
                deleteApp(appForDelete.appId);
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.confirm-delete-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const draftVersionTemplate = () => {
    return (
      <Modal className="delete-app-modal" size="md" isOpen={draftVersionShow}>
        <Flex direction="vertical" id="draft-modal">
          <Heading style={{ "margin-bottom": "10px" }}>
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.create-draft-app-from-live-text")} :<span className="appDelInfo">{appForDraft ? appForDraft.appName : ""}</span>
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24
          }}
        >
          <Text>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.sure-want-to-create-draft-version-text")}</Text>
          <div className="delInfo">
            <div className="delText">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.integration-details-section-text")}</div>
          </div>
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                closeDraftModal();
              }}
            >
              {i18n.t("partner-dashboard-app.auth.change-password.cancel-text")}
            </Button>
            <Button
              onClick={() => {
                makeDraftVersion(appForDraft);
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.create-draft-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const updateStagePopupTemplate = () => {
    return (
      <Modal className="delete-app-modal" size="md" isOpen={showUpdateStagePopup}>
        <Flex direction="vertical" id="draft-modal">
          <Heading>
            {updateStageMsgKeys.heading} :<span className="appDelInfo">{appForStageUpdate ? appForStageUpdate.appName : ""}</span>
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24,
            paddingBottom: 24,
            paddingTop: 24
          }}
        >
          <Heading style={{ "margin-bottom": "10px" }}>{updateStageMsgKeys.query} ?</Heading>
          {updateStageMsgKeys && updateStageMsgKeys.note ? (
            <div>
              <Text>
                {updateStageMsgKeys.note} : {appForStageUpdate ? appForStageUpdate.appName : ""} | {appForStageUpdate ? appForStageUpdate.version : ""}
              </Text>
              <Text>{updateStageMsgKeys.note2}</Text>
            </div>
          ) : (
            ""
          )}
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                cancelUpdateStagePopup();
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
            <Button
              onClick={() => {
                proceedToUpdateStage();
              }}
            >
              {updateStageMsgKeys.button}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const getActivationFullDetails = (activation) => {
    console.log("getActivationFullDetails::", activation);
    setActivationDetails({});
    setTimeout(() => {
      setActivationDetails(activation);
    }, 500);
  };

  useEffect(() => {
    if (activationDetails && activationDetails.activations) {
      console.log("activationDetails::", activationDetails);
      setShowActivationDetailsPopup(true);
    }
  }, [activationDetails]);

  const activationDetailsPopupTemplate = () => {
    return (
      activationDetails && (
        <Modal className="delete-app-modal" size="md" isOpen={showActivationDetailsPopup}>
          <Flex direction="vertical" id="activation-details-modal">
            <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.activation-details-text")}</Heading>
          </Flex>
          <Modal.Content
            style={{
              marginBottom: 24,
              marginTop: 24,
              paddingBottom: 24,
              paddingTop: 24
            }}
          >
            <div className="activationHeading">
              {!activationDetails.activations.activationDisplayName && activationDetails.activations.partnerTenantId
                ? activationDetails.activations.partnerTenantId
                : activationDetails.activations.activationDisplayName}
            </div>
            <div className="custActivationInfo">
              <div className="customerInfo">
                <div className="actHeading1">{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.customer-name-text")}</div>
                <div className="actHeading2">{activationDetails.customer}</div>
              </div>
              <div className="customerInfo">
                <div className="actHeading1">{i18n.t("partner-dashboard-app.partner-apps.app-settings.reference-id-text")}</div>
                <div className="actHeading2">{activationDetails.activations.activationRefId}</div>
              </div>
            </div>
            {activationDetails.activationMap && (
              <div className="locActivationInfo">
                <div className="locActivationTable">
                  <div className="locActivationHeading">
                    <div>{i18n.t("partner-dashboard-app.partner-apps.app-settings.location-name-text")}</div>
                    <div>{i18n.t("partner-dashboard-app.auth.activate-appuser.activate-account-text")}</div>
                  </div>
                  {activationDetails.activationMap.map((locData) => (
                    <div className="locActivationBody" key={locData.id}>
                      <div>{activationDetails.locationNames[locData.id] ? activationDetails.locationNames[locData.id] : "Location Unavailable"}</div>
                      <div>{locData.user}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Modal.Content>
          <Flex justify="flex-end">
            <Button.Group>
              <Button
                kind="tertiary"
                onClick={() => {
                  setShowActivationDetailsPopup(false);
                }}
              >
                {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
              </Button>
            </Button.Group>
          </Flex>
        </Modal>
      )
    );
  };

  const activationPopupTemplate = () => {
    return (
      <Modal className="activations-app-modal" size="xl" isOpen={showActivationPopup}>
        <Flex direction="vertical" id="activations-modal">
          <Heading>
            {activationApp?.draftConfig?.appName}
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-activations")}
          </Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24,
            paddingBottom: 24,
            paddingTop: 24
          }}
        >
          {showDeleteDueToActivationError && (
            <MNotification style={{ marginBottom: 24 }} status="negative">
              {i18n.t("partner-dashboard-app.partner-apps.app-center.note-text")} {deleteAppActivationErrorMsg}
            </MNotification>
          )}
          <div className="activationTable">
            <div className="activationTableHeader">
              <div>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.customer-name-text")}</div>
              <div>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.locations-activated-text")}</div>
              <div>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.last-activation-date")}</div>
              <div>{}</div>
            </div>
            {activations &&
              activations.length &&
              activations.map((activation) => (
                <div className="activationTableBody" key={`${activation._id}`}>
                  <div>{activation.customer}</div>
                  <div>
                    {activation.activations.locationIds && (
                      <span>
                        {activation.activations.locationIds.map((locId, j) => (
                          <span key={locId}>
                            {activation.locationNames[locId] ? activation.locationNames[locId] : "Location Unavailable"}
                            {j < activation.activations.locationIds.length - 1 && <span className="commaBlock">, </span>}
                          </span>
                        ))}
                      </span>
                    )}
                  </div>
                  <div>{activation.modifiedDate}</div>
                  {!showDeleteDueToActivationError ? (
                    <div>
                      <Button kind="tertiary" onClick={() => getActivationFullDetails(activation)} className="detailsLink">
                        Details
                      </Button>
                    </div>
                  ) : (
                    <div>{}</div>
                  )}
                </div>
              ))}
          </div>
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                setShowActivationPopup(false);
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  const submissionErrorPopupTemplate = () => {
    return (
      <Modal className="delete-app-modal" size="md" isOpen={showSubmissionErrorPopup}>
        <Flex direction="vertical" id="submission-error-modal">
          <Heading>{i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-submission-restricted-text")}</Heading>
        </Flex>
        <Modal.Content
          style={{
            marginBottom: 24,
            marginTop: 24,
            paddingBottom: 24,
            paddingTop: 24
          }}
        >
          <Heading>
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.app-text")}
            {`${appForSubmission.draftConfig.appName} `}
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.cannot-be-submitted-text")}
          </Heading>
          <Text style={{ marginTop: 20 }}>{submissionErrorMsg}</Text>
        </Modal.Content>
        <Flex justify="flex-end">
          <Button.Group>
            <Button
              kind="tertiary"
              onClick={() => {
                setShowSubmissionErrorPopup(false);
              }}
            >
              {i18n.t("partner-dashboard-app.partner-apps.app-settings.close-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  useEffect(() => {
    const propT = { ...properties };

    if (propT && propT.deleteAppActivationError) {
      setDeleteAppActivationErrorMsg(propT.deleteAppActivationError);
    } else {
      setDeleteAppActivationErrorMsg(i18n.t("partner-dashboard-app.partner-apps.partner-apps-list.some-error-on-activation"));
    }
    if (propT && propT.partnerDomainSetup && propT.partnerDomainSetup.toLowerCase() === "eu") {
      setIsEuDomain(true);
    }
    if (propT && propT.partnerDomainSetup && propT.partnerDomainSetup.toLowerCase() === "sg") {
      setIsSgDomain(true);
    }
  }, [properties]);

  useEffect(() => {
    console.log("ListApps Mount");
    getPartnerRegionStatus();

    const fapps = [];
    if (propsApps && propsApps.length) {
      propsApps.forEach((ap) => {
        if (ap.stage === "LIVE" && ap.draftConfig.version !== ap.version) {
          // Create a copy for 'live' editType
          const liveAp = { ...ap, editType: "live" };
          fapps.push(liveAp);
          // Create a copy for 'draft' editType
          const draftAp = { ...ap, editType: "draft" };
          fapps.push(draftAp);
        } else if (ap.stage === "LIVE") {
          // Create a copy for 'live' editType
          const liveAp = { ...ap, editType: "live" };
          fapps.push(liveAp);
        } else {
          // Create a copy for 'draft' editType
          const draftAp = { ...ap, editType: "draft" };
          fapps.push(draftAp);
        }
      });
      setApps(fapps);
    }
    return () => {
      console.log("ListApps Destroy");
    };
  }, []);

  return (
    <div className="app-tile">
      {firehoseWarningPopup()}
      {deleteAppTemplate()}
      {draftVersionTemplate()}
      {updateStagePopupTemplate()}
      {showActivationPopup && activationPopupTemplate()}
      {showActivationDetailsPopup && activationDetailsPopupTemplate()}
      {rejectedDetailsPopup && rejectionDetailsTemplate()}
      {showSubmissionErrorPopup && submissionErrorPopupTemplate()}
      {isEditAppPopupOpen && (
        <AdminAppApproval
          appData={appData}
          i18n={i18n}
          isPartnerDashboard
          isEditAppPopupOpen={isEditAppPopupOpen}
          selectedPartnerApp={selectedPartnerApp}
          cancelEditAppPopup={cancelEditAppPopup}
          adminAction="previewApp"
        />
      )}
      <Card.Group>{apps && apps.length && apps.map((app, index) => cardContainerTemplate(app, index))}</Card.Group>
    </div>
  );
}

export default ListApps;
